(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var TL = function (cents) {
    var v = cents / 100;
    return v.toLocaleString('tr-TR', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' TL';
  };
  var V = window.VRN || {};

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* reveal on scroll */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      $$('.reveal').forEach(function (el, i) { el.style.transitionDelay = (i % 3) * 70 + 'ms'; io.observe(el); });
    } else { $$('.reveal').forEach(function (el) { el.classList.add('in'); }); }

    /* Istanbul clock helpers for same-day shipping */
    var cutoff = +(V.cutoff || 16);
    var days = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
    function istanbul() {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return { wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday), secs: (+p.hour % 24) * 3600 + +p.minute * 60 + +p.second };
    }
    function nextShipDay(wd) { var n = (wd + 1) % 7; if (n === 0) n = 1; return n === (wd + 1) % 7 ? 'yarın' : days[n]; }
    var bar = $('[data-cutoff-bar]'), barText = $('[data-bar-text]'), barCd = $('[data-bar-cd]');
    var pad = function (x) { return String(x).padStart(2, '0'); };
    function tickBar() {
      var t = istanbul(), left = cutoff * 3600 - t.secs;
      if (t.wd !== 0 && left > 0) {
        if (barText) barText.innerHTML = '🚚 Aynı gün kargo için kalan süre';
        if (barCd) { barCd.hidden = false; barCd.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left % 3600 / 60)) + ':' + pad(left % 60); }
      } else {
        if (barText) barText.innerHTML = '🚚 Şimdi sipariş ver, <b>' + nextShipDay(t.wd) + '</b> ilk iş kargoda · Ücretsiz kargo · Güvenli ödeme';
        if (barCd) barCd.hidden = true;
      }
    }
    if (bar) { tickBar(); setInterval(tickBar, 1000); }
    function tickDeliver() {
      $$('[data-cutoff-text]').forEach(function (el) {
        var t = istanbul(), left = cutoff * 3600 - t.secs;
        if (t.wd !== 0 && left > 0) {
          var h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60);
          el.innerHTML = '<b>' + (h ? h + ' sa ' : '') + m + ' dk</b> içinde sipariş verirsen bugün kargoda';
        } else {
          el.innerHTML = 'Şimdi sipariş ver, <b>' + nextShipDay(t.wd) + '</b> ilk iş kargoda';
        }
      });
    }
    tickDeliver(); setInterval(tickDeliver, 30000);

    /* mobile menu */
    var menu = $('[data-menu]');
    function toggleMenu(open) { if (!menu) return; menu.classList.toggle('is-open', open); menu.setAttribute('aria-hidden', String(!open)); document.body.style.overflow = open ? 'hidden' : ''; }
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { toggleMenu(true); }); });
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { toggleMenu(false); }); });
    if (menu) menu.addEventListener('click', function (e) { if (e.target === menu || e.target.closest('a')) toggleMenu(false); });

    /* gallery */
    $$('[data-gallery]').forEach(function (g) {
      var slides = $$('[data-slide]', g), thumbs = $$('[data-thumb]', g), cur = $('[data-current]', g), idx = 0;
      function go(n) {
        if (!slides.length) return;
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
        if (cur) cur.textContent = idx + 1;
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
      var p = $('[data-prev]', g), n = $('[data-next]', g);
      if (p) p.addEventListener('click', function () { go(idx - 1); });
      if (n) n.addEventListener('click', function () { go(idx + 1); });
      var main = $('.main', g), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); x0 = null; });
      }
    });

    /* cart */
    var drawer = $('[data-drawer]'), toastEl = $('#vrnToast'), toastT;
    function toast(msg) { if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 3200); }
    function setCount(n) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
      $$('[data-cart-count-label]').forEach(function (el) { el.textContent = '(' + n + ')'; });
    }
    function openDrawer(open) {
      if (!drawer) return false;
      drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
      return true;
    }
    function bindLines() {
      $$('[data-line-qty]').forEach(function (b) {
        if (b._b) return; b._b = 1;
        b.addEventListener('click', function () {
          var line = +b.closest('[data-line]').dataset.line;
          b.closest('.line').style.opacity = '.5';
          fetch(V.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: +b.dataset.lineQty }) }).then(refreshCart);
        });
      });
    }
    function refreshCart() {
      return fetch((V.rootUrl || '/').replace(/\/$/, '') + '/?sections=cart-drawer-content').then(function (r) { return r.json(); }).then(function (data) {
        var doc = new DOMParser().parseFromString(data['cart-drawer-content'], 'text/html');
        var inner = doc.querySelector('.shopify-section') || doc.body;
        var body = $('[data-drawer-body]'); if (body) body.innerHTML = inner.innerHTML;
        var page = $('[data-cart-page]'); if (page) page.innerHTML = inner.innerHTML;
        return fetch('/cart.js');
      }).then(function (r) { return r.json(); }).then(function (cart) { setCount(cart.item_count); bindLines(); });
    }
    bindLines();
    $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { if (openDrawer(true)) e.preventDefault(); }); });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { openDrawer(false); toggleMenu(false); } });

    function addItems(id, qty) {
      return fetch(V.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: id, quantity: qty }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Ürün sepete eklenemedi.'); }); return r.json(); });
    }

    /* quick add on product cards */
    $$('[data-quick-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var orig = b.innerHTML; b.classList.add('is-loading'); b.textContent = 'Ekleniyor…';
        addItems(b.dataset.quickAdd, 1).then(refreshCart).then(function () { openDrawer(true); })
          .catch(function (e) { toast(e.message); })
          .then(function () { b.classList.remove('is-loading'); b.innerHTML = orig; });
      });
    });

    /* purchase module */
    $$('[data-buy]').forEach(function (box) {
      var form = $('[data-product-form]', box); if (!form) return;
      var price = +box.dataset.price, qtyInput = $('[data-qty]', form), btnTotal = $('[data-btn-total]', box), tiers = $$('.tier', form);
      function update() {
        var sel = $('.tier input:checked', form);
        var q = sel ? +sel.value : Math.max(1, +(qtyInput && qtyInput.value || 1));
        var off = sel ? +sel.dataset.off : 0;
        if (qtyInput) qtyInput.value = q;
        tiers.forEach(function (t) { t.classList.toggle('sel', !!sel && t.contains(sel)); });
        if (btnTotal) btnTotal.textContent = (q > 1 ? q + ' set · ' : '') + TL((price - off) * q);
      }
      tiers.forEach(function (t) { $('input', t).addEventListener('change', update); });
      var minus = $('[data-qty-minus]', form), plus = $('[data-qty-plus]', form);
      if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, +qtyInput.value - 1); update(); });
      if (plus) plus.addEventListener('click', function () { qtyInput.value = +qtyInput.value + 1; update(); });
      if (qtyInput && !tiers.length) qtyInput.addEventListener('change', update);
      update();

      var mode = 'checkout';
      var bn = $('[data-buy-now]', form), ac = $('[data-add-to-cart]', form);
      if (bn) bn.addEventListener('click', function () { mode = 'checkout'; });
      if (ac) ac.addEventListener('click', function () { mode = 'cart'; });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = mode === 'cart' ? ac : bn;
        if (btn) btn.classList.add('is-loading');
        addItems($('input[name="id"]', form).value, +qtyInput.value || 1).then(function () {
          if (mode === 'checkout') { window.location.href = '/checkout'; return; }
          return refreshCart().then(function () { openDrawer(true); });
        }).catch(function (err) { toast(err.message); })
          .then(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });

    /* sticky mobile buy bar */
    var sticky = $('[data-sticky-buy]'), mainForm = $('.pdp-sec [data-product-form]');
    if (sticky && mainForm && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('has-sticky', show);
      }).observe(mainForm);
      $('[data-sticky-go]', sticky).addEventListener('click', function () { mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    /* FAQ search + filter */
    $$('[data-faq]').forEach(function (f) {
      var items = $$('.qa', f), groups = $$('.faq-group', f), chips = $$('[data-faq-filter]', f), search = $('[data-faq-search]', f), none = $('[data-faq-none]', f), group = '';
      var norm = function (s) { return s.toLocaleLowerCase('tr-TR'); };
      function apply() {
        var q = norm(search ? search.value.trim() : ''), shown = 0;
        items.forEach(function (it) {
          var ok = (!group || it.dataset.group === group) && (!q || norm(it.textContent).indexOf(q) > -1);
          if (ok) { it.removeAttribute('data-hide'); shown++; if (q) it.open = true; } else it.setAttribute('data-hide', '');
        });
        groups.forEach(function (g) {
          var any = items.some(function (it) { return it.dataset.group === g.dataset.group && !it.hasAttribute('data-hide'); });
          if (any) g.removeAttribute('data-hide'); else g.setAttribute('data-hide', '');
        });
        if (none) none.hidden = shown > 0;
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { group = c.dataset.faqFilter; chips.forEach(function (x) { x.classList.toggle('is-active', x === c); }); apply(); }); });
      if (search) search.addEventListener('input', apply);
    });
  });
})();
